const themeVariants = {
	PRIMARY: '004258',
	FROST: 'e4f2e7',
	WHITE: 'f6f9e2',
};
export default themeVariants;
